import { __awaiter } from "tslib";
import { MODAL_TYPE } from "../services/modal_service.js";
function getSearchModel() {
    const $enableRegular = $('#enableRegular');
    const $enableLoting = $('#enableLoting');
    const enableRegular = $enableRegular.is(':checked');
    const enableLoting = $enableLoting.is(':checked');
    if (enableRegular) {
        if (enableLoting) {
            return '%';
        }
        else {
            return 'Regulier aanbod';
        }
    }
    else {
        if (enableLoting) {
            return 'Loting';
        }
    }
}
function run() {
    $(() => __awaiter(this, void 0, void 0, function* () {
        try {
            const $maxRegular = $('#maxRegular');
            const $maxLoting = $('#maxLoting');
            const $strategyRegular = $('#searchStrategyRegular');
            const $strategyLoting = $('#searchStrategyLoting');
            const $strategy = $('#searchStrategy');
            const $searchModel = $('#searchModel');
            // $strategy.on('change', () => updatePreferences({ strategy: $strategy.val() }))
            // $searchModel.on('change', () => updatePreferences({ model: $searchModel.val() }))
            const $save = $('#save');
            $save.on('click', () => __awaiter(this, void 0, void 0, function* () {
                const searchModel = getSearchModel();
                if (searchModel === undefined) {
                    return modalService.create({
                        title: 'Oeps!',
                        content: ( /*html*/`Het is vereist om een zoekmodel aan te zetten!<br>Kies tussen Reguliere- & Loting Woningen`)
                    });
                }
                try {
                    const data = {
                        model: searchModel,
                        strategyRegular: $strategyRegular.val(),
                        strategyLoting: $strategyLoting.val(),
                        maxRegular: $maxRegular.val(),
                        maxLoting: $maxLoting.val()
                    };
                    const { pathname } = location;
                    const useAbsoluteEndpoint = pathname.startsWith('/user/') && pathname.endsWith('/strategy');
                    const endpoint = useAbsoluteEndpoint ? pathname : '/strategy';
                    const res = yield Loading.await(api.put(endpoint, data));
                    if (res.success === false) {
                        const modal = modalService.create({ title: 'Oeps!', content: res.msg, type: MODAL_TYPE.YESNO });
                        if (res.askUserToUpgrade) {
                            modal.onProceed(() => {
                                location.href = '/subscriptions';
                            });
                        }
                        return;
                    }
                    modalService.create({
                        title: 'Succes!',
                        content: 'Je account strategie is aangepast!'
                    });
                }
                catch (err) {
                    console.error(err);
                    modalService.error(err);
                }
            }));
            // const { enlistingData } = await fetchDashboardData()
            // loadTimelineChart('timeline', enlistingData)
            // loadBarChart('barchart', enlistingData)
        }
        catch (err) {
            console.error(err);
            modalService.error(err);
        }
    }));
}
export const page_strategy = {
    requiresAuth: true,
    run: run,
};
//# sourceMappingURL=strategy.js.map